import type { LoaderFunctionArgs } from '~/types/route-args';
import type { ShouldRevalidateFunction } from 'react-router';
import { getCombinedNotifications } from '~/modules/notifications/api/get-combined-notifications.server';

export const NOTIFICATIONS_API = '/remix-api/user/notifications';

/**
 * API endpoint to get the notifications for the current user. Use with the
 * `useNotifications` hook.
 * @see {@link packages/web/app/modules/notifications/hooks/useNotifications.ts}
 */
export const loader = async ({ context }: LoaderFunctionArgs) => {
    return getCombinedNotifications(context);
};

export type NotificationLoaderData = typeof loader;

export const shouldRevalidate: ShouldRevalidateFunction = () => {
    // On revalidation, the root _app.tsx loader will contain the new
    // notifications, so don't need to revalidate this endpoint.
    return false;
};
